import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { getAuthToken } from '@src/services/auth-service';

import { HubEventHandlersGetResponseDTO } from './dto/hub-event-handlers.get.response.dto';

export class HubEventHandlersService {
  private readonly client: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/event-handlers`, client.getTimeout());
  }

  async get(request: {
    params: {
      organizationId: string;
    };
    settings?: RetrySettings;
  }): Promise<HubEventHandlersGetResponseDTO> {
    return (
      await this.client.get<HubEventHandlersGetResponseDTO>(``, request.params, {
        bearerToken: await getAuthToken(),
        settings: request.settings,
      })
    ).data;
  }
}
